import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Events from '@activebrands/core-web/libs/Events';
import { CheckoutEvents } from '@activebrands/core-web/libs/Events/types';
import { CheckoutTracking } from '@activebrands/core-web/libs/Tracking/constants';
import { addBasketInformation } from '@activebrands/core-web/state/basket/actions';

const CentraCheckoutScript = () => {
    const dispatch = useDispatch();

    const basket = useSelector(state => state.basket);

    const checkoutEventListener = useRef(null);

    const [paymentLoaded, setPaymentLoaded] = useState(false);
    const [shippingLoaded, setShippingLoaded] = useState(false);

    const { centraCheckoutScript } = basket;

    const centraCheckoutCallback = origdata => {
        if (origdata.detail) {
            const data = { ...origdata.detail };
            // It should be address, not billingAddress.
            if (data.billingAddress) {
                data.address = { ...data.billingAddress };
                delete data.billingAddress;
            }

            dispatch(addBasketInformation(data)).then(() => {
                window.CentraCheckout && window.CentraCheckout.resume(data.additionalFields.suspendIgnore);
            });
        }
    };

    const loadScript = () => {
        // If document is undefined, don't to anything.
        if (typeof document === 'undefined') {
            return;
        }

        const existingScriptElement = document.getElementById('centra_checkout_script');

        if (existingScriptElement) {
            // Remove the existing script so we're sure that the code is executed again.
            document.body.removeChild(existingScriptElement);
        }

        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.innerHTML = centraCheckoutScript;
        scriptElement.id = 'centra_checkout_script';
        document.getElementsByTagName('body')[0].appendChild(scriptElement);
    };

    useEffect(() => {
        checkoutEventListener.current = Events.subscribe(CheckoutEvents.OPTION, data => {
            setShippingLoaded(data.step === CheckoutTracking.SHIPPING_STEP);
            setPaymentLoaded(data.step === CheckoutTracking.PAYMENT_STEP);
        });

        loadScript();

        document.addEventListener('centra_checkout_callback', centraCheckoutCallback);

        return () => {
            document.removeEventListener('centra_checkout_callback', centraCheckoutCallback);
            const existingScriptElement = document.getElementById('centra_checkout_script');

            if (existingScriptElement) {
                // Remove it so we're sure that the code is executed again.
                document.body.removeChild(existingScriptElement);
            }

            if (checkoutEventListener.current) {
                Events.unsubscribe(CheckoutEvents.OPTION, checkoutEventListener.current);
            }

            // Remove CentraCheckout from the window object.
            // This is needed so we can baseline some functionality that depends upon window.CentraCheckout existing or not.
            // If it would still exist and be called, it might cause unexpected behaviour.
            window.CentraCheckout = undefined;
        };
    }, []);

    useEffect(() => {
        loadScript();
    }, [centraCheckoutScript, shippingLoaded, paymentLoaded]);

    // useEffect(() => document.removeEventListener('centra_checkout_callback', centraCheckoutCallback), []);

    return null;
};

export default CentraCheckoutScript;
